export const SIDE_NAVIGATION_WIDTH = 224
export const SIDE_NAVIGATION_CLOSED_WIDTH = 48
